import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3001');
const API_PREFIX = `${API_BASE_URL}/api`;

// Configuration axios avec gestion d'erreurs pour viewsService
axios.interceptors.response.use(
  (response) => {
    // Vérifier si la réponse est du HTML au lieu de JSON
    const contentType = response.headers['content-type'] || '';
    if (!contentType.includes('application/json') && typeof response.data === 'string') {
      if (
        response.data.trim().startsWith('<!DOCTYPE') ||
        response.data.trim().startsWith('<html')
      ) {
        console.error('❌ Réponse HTML détectée au lieu de JSON:', response.data.substring(0, 200));
        return Promise.reject(
          new Error(
            'Le serveur a retourné une page HTML au lieu de JSON - vérifiez que le serveur est démarré correctement'
          )
        );
      }
    }
    return response;
  },
  (error) => {
    // Vérifier si l'erreur contient une réponse HTML
    if (error.response && error.response.data && typeof error.response.data === 'string') {
      const responseText = error.response.data.trim();
      if (responseText.startsWith('<!DOCTYPE') || responseText.startsWith('<html')) {
        console.error('❌ Erreur avec réponse HTML:', responseText.substring(0, 200));
        return Promise.reject(
          new Error(
            "Le serveur a retourné une page d'erreur HTML - vérifiez que l'API est accessible"
          )
        );
      }
    }
    return Promise.reject(error);
  }
);

export async function trackTableauView(
  tableauId,
  { sessionId, duration, interactions, scrollDepth, cameFrom } = {}
) {
  try {
    // POST /api/views/:tableauId incrémente tableaux.vues (compteur admin)
    const res = await axios.post(`${API_PREFIX}/views/${tableauId}`, {
      sessionId,
      durationSeconds: duration,
      interactionsCount: interactions,
      scrollDepth,
      cameFrom,
    });
    return { success: true, data: res.data };
  } catch (error) {
    console.error('trackTableauView error', error);
    return { success: false, error: error.message };
  }
}

export async function getViewsStatistics() {
  try {
    const res = await axios.get(`${API_PREFIX}/views`);
    return Array.isArray(res.data) ? res.data : [];
  } catch (error) {
    console.error('getViewsStatistics error', error);
    return [];
  }
}
